// hooks/useMotionPreferences.ts
import { useState, useEffect } from 'react';

export const useMotionPreferences = (initDelay: number = 100) => {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState<boolean>(true); // Start safe
  const [isInitialized, setIsInitialized] = useState<boolean>(false);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    
    const handleChange = (e: MediaQueryListEvent) => {
      setPrefersReducedMotion(e.matches);
    };

    // Progressive enhancement approach
    const initTimer = setTimeout(() => {
      setPrefersReducedMotion(mediaQuery.matches);
      setIsInitialized(true);
      
      // Stagger loading for smoother experience
      setTimeout(() => setIsLoaded(true), 50);
    }, initDelay);

    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
      clearTimeout(initTimer);
    };
  }, [initDelay]);

  return {
    prefersReducedMotion,
    isInitialized,
    isLoaded
  };
};